import { differenceInMilliseconds, isBefore, intervalToDuration, addMilliseconds } from 'date-fns';

export const getRemainingMs = (lastAt: number, intervalMs: number): number => {
  if (!lastAt) return 0;

  const nextAllowed = addMilliseconds(lastAt, intervalMs);
  const now = new Date();

  return isBefore(nextAllowed, now) ? 0 : differenceInMilliseconds(nextAllowed, now);
};

export const formatDuration = (ms: number): string => {
  const d = intervalToDuration({ start: 0, end: ms });

  const days = d.days ?? 0;
  const hours = String(d.hours ?? 0).padStart(2, '0');
  const minutes = String(d.minutes ?? 0).padStart(2, '0');
  const seconds = String(d.seconds ?? 0).padStart(2, '0');

  if (days > 0) {
    return `${days}:${hours}:${minutes}:${seconds}`;
  }

  return `${hours}:${minutes}:${seconds}`;
};
